import { AlertTriangle } from 'blaze-ui/icons'
import { Input } from 'almanac-ui/TextInputField/Input'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import Styles from '../GeneratedContent.module.scss'

interface CaptionDisplayProps {
  streaming: boolean
  content: string
  hasError: boolean
  displayedCaption: string
  disabled?: boolean
}

export const CaptionDisplay = ({
  streaming,
  content,
  hasError,
  displayedCaption,
  disabled = false,
}: CaptionDisplayProps) => {
  if (!streaming && !content && !hasError) {
    return <TextFieldLoadingState lines={6} />
  }

  if (hasError) {
    return (
      <div className={Styles.errorMessage}>
        <AlertTriangle />
        <span>Failed to generate caption. Please try again.</span>
      </div>
    )
  }

  return <Input value={displayedCaption} name="caption" isTextarea disabled={disabled} aria-label="caption" />
}
